module.exports = __webpack_public_path__ + "static/media/truckTick.f77615a2.svg";